<template>
  <div class="mypage-ec-site-connect-contact-parts">
    <h3
      class="mypage-ec-site-connect-contact-parts__title"
      v-html="$tc('MypagePage.MypageContactUsPage.titleEmail')"
    />
    <div class="mypage-ec-site-connect-contact-parts__button">
      <atom-link-button
        :linkText="$tc('MypagePage.MypageContactUsPage.toContactForm')"
        :url="inquiryFormUrl"
        :isDisabled="true"
        colorType="secondary"
      />
    </div>
    <p class="mypage-ec-site-connect-contact-parts__attention-inquiry">
      {{ $tc('MypagePage.MypageContactUsPage.attentionInquiry') }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import AtomLinkButton from '@/components/atoms/AtomLinkButton.vue'
import Const from '@/util/Const'

export default defineComponent({
  name: 'MypageEcSiteConnectContactParts',
  components: {
    AtomLinkButton,
  },
  setup() {
    // お問い合わせフォームへのリンク
    const inquiryFormUrl = Const.EXTERNAL_LINKS.GOOGLE_INQUIRY_FORM

    return {
      inquiryFormUrl,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-ec-site-connect-contact-parts {
  &__title {
    font-size: 17px;
    font-weight: 500;
    letter-spacing: 0.04em;
  }

  &__button {
    margin-top: 12px;
  }

  &__attention-inquiry {
    margin-top: 12px;
  }
}
</style>
